//#region src/unleadingSlashIt.ts
/**
* Removes a leading / from a string
* @category Strings
*/
const unleadingSlashIt = (s) => s.replace(/^\/+/, "");
var unleadingSlashIt_default = unleadingSlashIt;

//#endregion
export { unleadingSlashIt_default };